/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { memo } from 'react';
import {
  DataContextProvider,
  IDataConnectorConfigRaw
} from '@forge/data-connector';
import IEnergyManagementProps from '../../DashboardKPIWidgets/IEnergyManagementProps';
import CarbonSiteViewDetailsComponentContent from './CarbonSiteViewDetailsComponentContent';
import { ContextProvider, updateApiConfig } from '../../../context/ApiContext';
import { shouldComponentNotUpdateOnDateChange } from '../../shared/Utils/Utils';
import { withLocalization } from '../../../locales/withLocalization';
// import { isObjectWithNonNullValue, shouldComponentNotUpdateOnDateChange } from '../../shared/Utils/Utils';
// import { isUndefinedOrNullCheck } from '../../VirtualMeters/ElectircMeterIcon';

const CarbonSiteViewDetailsComponent = memo((props: IEnergyManagementProps) => {
  const { connectorConfig, bearerToken, requestContext, emaasContext } = props;

  return (
    <ContextProvider
      value={updateApiConfig({
        connectorConfig,
        ...emaasContext
      })}
    >
      <DataContextProvider config={connectorConfig}>
        <div className="carbondetail-viewdetails-dashboard">
          <CarbonSiteViewDetailsComponentContent
            requestContext={requestContext}
            bearerToken={bearerToken}
            connectorConfig={connectorConfig}
            emaasContext={emaasContext}
          />
        </div>
      </DataContextProvider>
    </ContextProvider>
  );
}, shouldComponentNotUpdateOnDateChange);

export default withLocalization<IEnergyManagementProps>(
  CarbonSiteViewDetailsComponent
);
